import { message, Row, Col } from "antd";
import axios from "axios";
import { Divider } from "rc-menu";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import PermisosEditor from "../../PermisosEditor";

class EditarPerfil extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    permisosValues: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  cerrarEditarPerfil(codigo) {
    this.props.cerrarEditarPerfil(codigo);
  }

  // ---- Modelo de valor para PermisosEditor ----

  getEstadoPermiso = (id) => {
    const pv = this.state.permisosValues.find((p) => p.permisoId === id);
    return pv
      ? { activado: pv.activado, valor: pv.valor }
      : { activado: false, valor: null };
  };

  onToggleVarios = (ids, checked) => {
    const permisosValues = [...this.state.permisosValues];
    ids.forEach((id) => {
      const i = permisosValues.findIndex((p) => p.permisoId === id);
      if (i === -1) {
        permisosValues.push({ permisoId: id, activado: checked, valor: null });
      } else {
        permisosValues[i] = { ...permisosValues[i], activado: checked };
      }
    });
    this.setState({ permisosValues });
  };

  onChangeValor = (id, valor) => {
    const permisosValues = [...this.state.permisosValues];
    const i = permisosValues.findIndex((p) => p.permisoId === id);
    if (i === -1) {
      permisosValues.push({ permisoId: id, activado: false, valor });
    } else {
      permisosValues[i] = { ...permisosValues[i], valor };
    }
    this.setState({ permisosValues });
  };

  // ---- Carga del perfil a editar ----

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "perfiles/datosPerfil",
        { perfilId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del perfil");
        } else {
          this.formRef.current.setFieldsValue({ ...res.data });
          this.setState({
            permisosValues: (res.data.permisos || []).map((valuePermiso) => ({
              permisoId: valuePermiso.permisoId.toString(),
              activado: valuePermiso.activado,
              valor: valuePermiso.valor ?? null,
            })),
          });
        }
      });
    this.setState({ loading: false });
  }

  // ---- Submit ----

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "perfiles/editarPerfil",
        {
          ...values,
          permisos: this.state.permisosValues,
          perfilId: this.props.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha editado un perfil");
          this.formRef.current.resetFields();
          this.setState({ permisosValues: [] });
          this.cerrarEditarPerfil(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error("No se puede editar el perfil");
        } else {
          message.error("Hubo un error y el perfil no se edito");
        }
      });
  }

  cerrarModalEditarPerfil() {
    this.formRef.current.resetFields();
    this.setState({ loading: false, permisosValues: [] });
    this.cerrarEditarPerfil();
  }

  render() {
    return (
      <>
        <ModalItem
          title="Editar Perfil"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarModalEditarPerfil.bind(this)}
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="editarPerfil"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Guardar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Row>
              <Col span={12}>
                <FormItem
                  name="nombre"
                  label="Nombre"
                  required
                  max={100}
                  margin
                  pattern
                >
                  <InputItem placeholder="Nombre" />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  name="descripcion"
                  label="Descripcion"
                  required
                  max={100}
                  margin
                  pattern
                >
                  <InputItem placeholder="Descripcion" />
                </FormItem>
              </Col>
            </Row>
            <Divider
              style={{ marginBottom: 10, marginTop: 5 }}
              children="Permisos"
            />
            <PermisosEditor
              headersToken={this.props.headersToken}
              tipo={this.props.tipo}
              usuarioPrincipal={this.props.usuarioPrincipal}
              getEstadoPermiso={this.getEstadoPermiso}
              onToggleVarios={this.onToggleVarios}
              onChangeValor={this.onChangeValor}
              mostrarSeleccionarTodos
            />
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioPrincipal: state.user.usuarioPrincipal,
    empresaId: state.empresa.id,
    tipo: state.user.tipo,
  };
};

export default connect(mapStateToProps)(EditarPerfil);
